import reportUtils from "../report/reportutils"

const exceptionalRdcquestions=[

  //schema for Conditional field:- [Field that controls conditions, [Area of possible returns at cause filed to be displayed]. (optional) "Required"- field must be completed if desplayed.]   Can also use Required:true property on object to may filed compulsory but will cause problem if used on Conditional field since prevents submit if not displayed.

    {
    label:"Which RDC clinic do you want to refer to",
    controlType:"dropdown",
    options:[...reportUtils.rdcClinicsAvailable()],// gets available RDC paths from validatorIndex
    required:true
    },

    {
    label:"Reason for Referral",
    controlType:"radio button",
    options:["Suspicion of cancer on imaging or endoscopy", "Histological proof of cancer", "Concerning lab test" , "Strong clinical suspicion"] ,
    required:true 
    },

    {
    label:"Hospital where investigation performed",
    controlType:"radio button",
    options:[...reportUtils.localHospitals()],//gets list of area local hospitals from hospitalclinics file in utilities/clinic questions
    Conditional:["Reason for Referral", ["Suspicion of cancer on imaging or endoscopy", "Histological proof of cancer", "Concerning lab test"] ] 
    },

    {
    label:"Where was it performed",
    controlType:"text",
    options:[], //question appears if "Other" selected under hospital
    Conditional:["Hospital where investigation performed", ["Other"] ] 
    },

    {
    label:"Date of test or investigation",
    controlType:"date",
    options:[],
    Conditional:["Reason for Referral", ["Suspicion of cancer on imaging or endoscopy", "Histological proof of cancer", "Concerning lab test"] ] 
    },

    {
    label:"Type of imaging",
    controlType:"radio button",
    options:["X Ray", "Ultrasound", "CT", "MRI", "Upper GI endoscopy", "Lower GI endoscopy"],
    Conditional:["Reason for Referral", ["Suspicion of cancer on imaging or endoscopy" ], "Required"  ]
    },
 
  {
    label:"Type of Lab test",
    controlType:"text",
    options:[],
    Conditional:["Reason for Referral", ["Concerning lab test"],"Required"],
    },

    {label:"Result of lab test or histology",
    controlType:"textarea",
    options:[],
    Conditional:["Reason for Referral", ["Histological proof of cancer", "Concerning lab test"] ] 
    },

    
    {label:"Result of imaging or endoscopy",
    controlType:"textarea",
    options:[],
    Conditional:["Reason for Referral", ["Suspicion of cancer on imaging or endoscopy"] ] 
    },
    {
    label:"Reason for concern if not already outlined in clinical history",
    controlType:"textarea",
    options:[],
    Conditional:["Reason for Referral", ["Strong clinical suspicion"] ]  
    },

    ]


    export default exceptionalRdcquestions

